module.exports = __webpack_public_path__ + "static/media/packages.168d4165.svg";